module.exports = __webpack_public_path__ + "img/ic_head_hight_2.6aa35517.png";